/* Genuine, bounded browser history. This data never supplies product prices or account permissions. */
(function (root, factory) {
  'use strict';
  var library = factory();
  if (typeof module === 'object' && module.exports) module.exports = library;
  else library.mount(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var VERSION = 1;
  var MAX_VIEWS = 48;
  var MAX_SEARCHES = 12;
  var MAX_AGE = 180 * 24 * 60 * 60 * 1000;
  var FUTURE_TOLERANCE = 60 * 1000;
  var idPattern = /^[1-9][0-9]{0,24}$/;
  var handlePattern = /^[a-z0-9][a-z0-9-]{0,254}$/;

  function string(value) { return typeof value === 'string' ? value : ''; }
  function id(value) {
    var candidate = typeof value === 'number' && Number.isSafeInteger(value) ? String(value) : string(value);
    return idPattern.test(candidate) ? candidate : '';
  }
  function text(value, limit) {
    return string(value).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, limit);
  }
  function normalizeContext(input) {
    if (!input || typeof input !== 'object') return null;
    var shop = string(input.shop).toLowerCase();
    if (!/^[a-z0-9](?:[a-z0-9.-]{0,251}[a-z0-9])?\.[a-z]{2,63}$/.test(shop) || shop.indexOf('..') !== -1) return null;
    var customer = input.customer === 'guest' ? 'guest' : id(input.customer);
    var hasCompany = input.company !== '' && input.company != null;
    var hasLocation = input.location !== '' && input.location != null;
    var company = hasCompany ? id(input.company) : '';
    var location = hasLocation ? id(input.location) : '';
    if (!customer || (hasCompany && !company) || (hasLocation && !location)) return null;
    if (customer === 'guest' && (company || location)) return null;
    return { shop: shop, customer: customer, company: company, location: location,
      pageType: string(input.pageType), designMode: input.designMode === true,
      product: input.product, searchQuery: input.searchQuery };
  }
  function getStorageKey(context) {
    var normalized = normalizeContext(context);
    return normalized ? 'saber:viewed-history:v1:' + [normalized.shop, normalized.customer, normalized.company, normalized.location].map(encodeURIComponent).join(':') : '';
  }
  function scopeToken(key) {
    // An opaque cache token, never an authorization token. The storage key retains the exact scope.
    var first = 2166136261;
    var second = 5381;
    for (var i = 0; i < key.length; i++) {
      first = Math.imul(first ^ key.charCodeAt(i), 16777619);
      second = Math.imul(second, 33) ^ key.charCodeAt(i);
    }
    return key ? 'v1-' + (first >>> 0).toString(36) + '-' + (second >>> 0).toString(36) : '';
  }
  function validTime(value, now) {
    return typeof value === 'number' && Number.isSafeInteger(value) && value > 0 && value >= now - MAX_AGE && value <= now + FUTURE_TOLERANCE;
  }
  function productUrl(value, handle, origin, variantId) {
    if (typeof value !== 'string' || !value || value.length > 1500 || /[\s\u0000-\u001f\u007f\\]/.test(value) || /(?:^|\/)\.{1,2}(?:\/|[?#]|$)/.test(value) || value.indexOf('//') === 0) return '';
    try {
      var url = new URL(value, origin);
      if (url.origin !== new URL(origin).origin || url.username || url.password || !/^https?:$/.test(url.protocol)) return '';
      if (/%(?:2f|5c|2e)/i.test(url.pathname) || !url.pathname.endsWith('/products/' + handle)) return '';
      if (!/^\/(?:[a-zA-Z0-9_-]+\/)*products\/[a-z0-9-]+$/.test(url.pathname)) return '';
      var selected = variantId || id(url.searchParams.get('variant'));
      return url.pathname + (selected ? '?variant=' + selected : '');
    } catch (_) { return ''; }
  }
  function cleanView(input, now, origin) {
    if (!input || typeof input !== 'object') return null;
    var productId = id(input.id);
    var handle = string(input.handle);
    var hasVariant = input.variantId !== '' && input.variantId != null;
    var variantId = hasVariant ? id(input.variantId) : '';
    if (!productId || !handlePattern.test(handle) || !validTime(input.viewedAt, now) || (hasVariant && !variantId)) return null;
    var url = productUrl(input.url, handle, origin, variantId);
    if (!url) return null;
    return { id: productId, handle: handle, url: url, title: text(input.title, 300), variantId: variantId,
      variantTitle: text(input.variantTitle, 180), viewedAt: input.viewedAt };
  }
  function cleanSearch(input, now) {
    if (!input || typeof input !== 'object' || typeof input.query !== 'string' || input.query.length > 120 || /[\u0000-\u001f\u007f]/.test(input.query)) return null;
    var query = input.query.replace(/\s+/g, ' ').trim();
    return query.length >= 2 && validTime(input.searchedAt, now) ? { query: query, searchedAt: input.searchedAt } : null;
  }
  function cleanState(input, now, origin) {
    if (!input || input.version !== VERSION) return { version: VERSION, views: [], searches: [] };
    var ids = new Set();
    var handles = new Set();
    var queries = new Set();
    var views = (Array.isArray(input.views) ? input.views.slice(0, 1000) : []).map(function (item) { return cleanView(item, now, origin); }).filter(Boolean).sort(function (a, b) { return b.viewedAt - a.viewedAt; }).filter(function (item) {
      if (ids.has(item.id) || handles.has(item.handle)) return false;
      ids.add(item.id); handles.add(item.handle); return true;
    }).slice(0, MAX_VIEWS);
    var searches = (Array.isArray(input.searches) ? input.searches.slice(0, 1000) : []).map(function (item) { return cleanSearch(item, now); }).filter(Boolean).sort(function (a, b) { return b.searchedAt - a.searchedAt; }).filter(function (item) {
      var key = item.query.toLocaleLowerCase('en-US');
      if (queries.has(key)) return false;
      queries.add(key); return true;
    }).slice(0, MAX_SEARCHES);
    return { version: VERSION, views: views, searches: searches };
  }
  function formatViewedDate(timestamp) {
    var date = new Date(timestamp);
    if (!Number.isFinite(date.getTime())) return '';
    return String(date.getMonth() + 1).padStart(2, '0') + '/' + String(date.getDate()).padStart(2, '0') + '/' + date.getFullYear();
  }
  function createHistory(options) {
    options = options || {};
    var context = normalizeContext(options.context);
    var key = getStorageKey(options.context);
    var origin = options.origin || 'https://invalid.example';
    var clock = typeof options.now === 'function' ? options.now : Date.now;
    var storage = options.storage || null;
    var available = !!(key && storage);
    var listeners = new Set();
    var state = cleanState(options.initialState, clock(), origin);
    var nativeProduct = context && context.pageType === 'product' && !context.designMode ? cleanView(Object.assign({}, context.product, { viewedAt: clock() }), clock(), origin) : null;
    function read() {
      if (!available) return;
      var raw;
      try { raw = storage.getItem(key); }
      catch (_) { available = false; state = cleanState(state, clock(), origin); return; }
      try {
        if (raw && raw.length > 200000) { state = cleanState(null, clock(), origin); return; }
        state = cleanState(raw ? JSON.parse(raw) : null, clock(), origin);
      } catch (_) { state = cleanState(null, clock(), origin); }
    }
    function snapshot() {
      state = cleanState(state, clock(), origin);
      return { ready: true, scope: scopeToken(key), storageAvailable: available, currentProductId: nativeProduct ? nativeProduct.id : '',
        views: state.views.map(function (item) { return Object.assign({}, item); }),
        searches: state.searches.map(function (item) { return Object.assign({}, item); }) };
    }
    function emit() {
      var current = snapshot();
      listeners.forEach(function (callback) { try { callback(current); } catch (_) { /* A consumer cannot interrupt other components. */ } });
      return current;
    }
    function write() {
      state = cleanState(state, clock(), origin);
      if (available) {
        try { storage.setItem(key, JSON.stringify(state)); }
        catch (_) { available = false; }
      }
      return emit();
    }
    read();
    return {
      snapshot: snapshot,
      recordPage: function () {
        if (!context || !key || context.designMode) return snapshot();
        if (context.pageType === 'product') {
          var view = cleanView(Object.assign({}, context.product, { viewedAt: clock() }), clock(), origin);
          if (view) { state.views = state.views.filter(function (item) { return item.id !== view.id && item.handle !== view.handle; }); state.views.unshift(view); return write(); }
        }
        if (context.pageType === 'search') {
          var search = cleanSearch({ query: context.searchQuery, searchedAt: clock() }, clock());
          if (search) { state.searches = state.searches.filter(function (item) { return item.query.toLocaleLowerCase('en-US') !== search.query.toLocaleLowerCase('en-US'); }); state.searches.unshift(search); return write(); }
        }
        return snapshot();
      },
      clear: function () {
        state = { version: VERSION, views: [], searches: [] };
        if (available) { try { storage.removeItem(key); } catch (_) { available = false; } }
        return emit();
      },
      remove: function (productId) {
        state.views = state.views.filter(function (item) { return item.id !== id(productId); });
        return write();
      },
      subscribe: function (callback) {
        if (typeof callback !== 'function') return function () {};
        listeners.add(callback); return function () { listeners.delete(callback); };
      },
      reload: function () { read(); return emit(); },
      storageKey: key
    };
  }
  function mount(win) {
    if (!win || !win.document || win.SaberViewedHistory) return;
    var doc = win.document;
    var current = null;
    var rawContext = null;
    var listeners = new Set();
    var unsubscribe = null;
    var contextNode = null;
    var contextObserver = null;
    var hydrating = false;
    var recordedEntries = new Set();
    function contextData() {
      var node = doc.getElementById('SaberRecommendationsContext');
      if (!node) return { node: null, raw: '', value: null };
      var raw = node.getAttribute('data-context') || '';
      try { return { node: node, raw: raw, value: JSON.parse(raw) }; }
      catch (_) { return { node: node, raw: raw, value: null }; }
    }
    function storage() { try { return win.localStorage; } catch (_) { return null; } }
    function dispatch(name) {
      doc.dispatchEvent(new win.CustomEvent(name, { detail: { history: api } }));
    }
    function refreshContext() {
      var data = contextData();
      if (current && rawContext === data.raw && contextNode === data.node) return false;
      rawContext = data.raw;
      contextNode = data.node;
      if (unsubscribe) unsubscribe();
      if (contextObserver) contextObserver.disconnect();
      var previous = current ? current.snapshot() : null;
      var nextKey = getStorageKey(data.value);
      var initialState = previous && previous.scope === scopeToken(nextKey) ? { version: VERSION, views: previous.views, searches: previous.searches } : null;
      current = createHistory({ context: data.value, storage: storage(), origin: win.location.origin, initialState: initialState });
      // Replacing a section/context node is not another visit. A genuine new scope/page can be recorded once.
      var normalized = normalizeContext(data.value);
      var entry = current.storageKey + ':' + (normalized ? normalized.pageType : '') + ':' + (normalized && normalized.product ? String(normalized.product.id) + ':' + String(normalized.product.url) : '') + ':' + (normalized ? string(normalized.searchQuery) : '');
      if (!recordedEntries.has(entry)) { recordedEntries.add(entry); current.recordPage(); }
      unsubscribe = current.subscribe(function (snapshot) {
        hydrate(doc, snapshot);
        listeners.forEach(function (callback) { try { callback(snapshot); } catch (_) {} });
        dispatch('saber:viewed-history-change');
      });
      if (contextNode && win.MutationObserver) {
        contextObserver = new win.MutationObserver(function () { if (refreshContext()) notifyContext(); });
        contextObserver.observe(contextNode, { attributes: true, attributeFilter: ['data-context'] });
      }
      return true;
    }
    function snapshot() {
      if (refreshContext()) notifyContext();
      return current.snapshot();
    }
    function badges(root) {
      var found = [];
      if (root && root.matches && root.matches('[data-saber-viewed-badge]')) found.push(root);
      if (root && root.querySelectorAll) found = found.concat(Array.from(root.querySelectorAll('[data-saber-viewed-badge]')));
      return found;
    }
    function hydrate(root, provided) {
      if (hydrating) return;
      hydrating = true;
      try {
        var records = (provided || (current ? current.snapshot() : snapshot())).views;
        var byId = new Map(records.map(function (item) { return [item.id, item]; }));
        badges(root || doc).forEach(function (badge) {
          var record = byId.get(badge.getAttribute('data-product-id'));
          var label = badge.querySelector('[data-saber-viewed-date]');
          var labelText = record ? 'Viewed ' + formatViewedDate(record.viewedAt) : '';
          if (label && label.textContent !== labelText) label.textContent = labelText;
          badge.hidden = !record;
          if (record) badge.setAttribute('aria-label', labelText + '. View your recommendations');
          else badge.setAttribute('aria-label', 'View your recommendations');
        });
      } finally { hydrating = false; }
    }
    function notifyContext() {
      var next = current.snapshot();
      hydrate(doc, next);
      listeners.forEach(function (callback) { try { callback(next); } catch (_) {} });
      dispatch('saber:viewed-history-change');
    }
    var api = {
      snapshot: snapshot,
      clear: function () { refreshContext(); return current.clear(); },
      remove: function (productId) { refreshContext(); return current.remove(productId); },
      subscribe: function (callback) {
        if (typeof callback !== 'function') return function () {};
        listeners.add(callback); return function () { listeners.delete(callback); };
      },
      hydrate: function (root) { var state = snapshot(); hydrate(root || doc, state); }
    };
    function start() {
      refreshContext();
      win.SaberViewedHistory = api;
      hydrate(doc, current.snapshot());
      dispatch('saber:viewed-history-ready');
      if (win.MutationObserver && doc.documentElement) {
        var observer = new win.MutationObserver(function (changes) {
          var changedContext = false;
          changes.forEach(function (change) {
            Array.from(change.addedNodes).forEach(function (node) {
              if (node.nodeType !== 1) return;
              if (node.id === 'SaberRecommendationsContext' || (node.querySelector && node.querySelector('#SaberRecommendationsContext'))) changedContext = true;
              if (node.matches('[data-saber-viewed-badge]') || node.querySelector('[data-saber-viewed-badge]')) hydrate(node, current.snapshot());
            });
            if (Array.from(change.removedNodes).some(function (node) { return node === contextNode || (node.contains && node.contains(contextNode)); })) changedContext = true;
          });
          if (changedContext && refreshContext()) notifyContext();
        });
        observer.observe(doc.documentElement, { childList: true, subtree: true });
      }
      win.addEventListener('storage', function (event) {
        var changed = refreshContext();
        if (event.key === current.storageKey || event.key === null) current.reload();
        else if (changed) notifyContext();
      });
      win.addEventListener('pageshow', function (event) {
        var changed = refreshContext();
        if (changed) notifyContext();
        // A back/forward-cache return is a real page visit, unlike card hydration or section replacement.
        else if (event.persisted) current.recordPage();
      });
      doc.addEventListener('shopify:section:load', function (event) { api.hydrate(event.target); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  }
  return { createHistory: createHistory, getStorageKey: getStorageKey, normalizeContext: normalizeContext, formatViewedDate: formatViewedDate, mount: mount };
});
